<mat-form-field appearance="outline" class="date-range-input-field" [style.height]="height">
    <mat-label>{{ label | translate }}</mat-label>
    <mat-date-range-input [formGroup]="rangeGroup" [rangePicker]="picker" [min]="minDate" [max]="maxDate"
        [required]="required" [disabled]="disabled" (dateInput)="onDateRangeInput()" (click)="picker.open()">
        <input matStartDate formControlName="start" (click)="picker.open()" readonly />
        <input matEndDate formControlName="end" (click)="picker.open()" readonly />
    </mat-date-range-input>
    <div class="date-input-suffixes" matSuffix>
        <button *ngIf="clearable && (rangeGroup.value.start || rangeGroup.value.end) && !disabled" matIconSuffix
            mat-icon-button type="button" (click)="clearDate($event)" class="clear-button"
            [title]="'common.clear' | translate" [attr.aria-label]="'common.clear' | translate" tabindex="0">
            <span class="clear-icon">✕</span>
        </button>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    </div>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>